module.exports = __webpack_public_path__ + "static/media/gidrama.0ff17871.jpg";